jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

/* de blinkie: disable theme tooltip on eyewear-style wishlist buttons (custom pill label instead) */
(function(){
  var SEC = '#shopify-section-template--21966618001581__tabs_collection_aCJzRG .t4s-product-btns2 .t4s-pr-item-btn';
  var TPL = '.template-collection .t4s-pr-style6 .t4s-product-btns2 .t4s-pr-item-btn, .template-search .t4s-pr-style6 .t4s-product-btns2 .t4s-pr-item-btn, .template-product .t4s-pr-style6 .t4s-product-btns2 .t4s-pr-item-btn';
  var ALL = SEC + ', ' + TPL;
  function strip(a){ if(!a) return; a.removeAttribute('data-tooltip'); a.classList.remove('t4s-tooltip-actived'); }
  function sweep(){ document.querySelectorAll(ALL).forEach(strip); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sweep); } else { sweep(); }
  setTimeout(sweep, 1500); setTimeout(sweep, 4000); setTimeout(sweep, 8000);
  document.addEventListener('click', function(){ setTimeout(sweep, 600); setTimeout(sweep, 1600); }, true);
  document.addEventListener('mouseover', function(e){ var t = e.target; if (t && t.closest) { strip(t.closest(ALL)); } }, true);
})();
